export default {
  "name": "NCStep",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCStep",
  "label": "步骤条",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "组件标识",
        "description": "组件标识",
        "type": "string"
      },
      "status": {
        "title": "当前step的状态",
        "description": "当前step的状态",
        "enumNames": [
          "等待",
          "进行中",
          "完成",
          "错误"
        ],
        "type": "enum",
        "enum": [
          "wait",
          "process",
          "finish",
          "error"
        ]
      },
      "title": {
        "title": "标题",
        "description": "标题",
        "type": "string"
      },
      "description": {
        "title": "描述",
        "description": "描述",
        "type": "string"
      },
      "icon": {
        "title": "图标",
        "description": "图标",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}